import { css } from 'styled-components';

import { fontSize, secondaryColor } from '@styles/utils';

export const datePickerOverwrite = css`
  .react-next-dates {
    --color-primary: ${secondaryColor(500)};
    --font-size-large: ${fontSize.standard};

    &.popper {
      z-index: 11000;
    }
  }
`;
